import {FaqData} from "./FaqData";

export  const Faqs = () :FaqData[] => [
    {
        question: 'Как скоро вы можете подготовить праздник?',
        answer: 'Обычно требуется 2–4 рабочих дней на подготовку полного\n' +
            ' сценария и реквизита. Для срочных заказов — уточняйте при звонке.'
    },
    {
        question: 'Вы предоставляете фотосъёмку?',
        answer: 'Да, есть отдельный модуль фото/видео. Можно заказать только аниматоров или пакет с фотографом.'
    },
    {
        question: 'Где можно провести праздник с вашим участием?',
        answer: 'Мы работаем в любых местах: дома, в кафе, детском саду, школе, парке, на площадке и т. д. Главное, чтобы было достаточно места для активностей.'
    },
    {
        question: 'Сколько стоит анимационная программа?',
        answer: 'Стоимость зависит от длительности программы, количества аниматоров, тематики и дополнительных услуг. ' +
            'Средняя цена — от 3000 до 8000 руб. Точную сумму рассчитает менеджер после уточнения деталей.'
    },
    {
        question: 'Что делать, если праздник придётся отменить или перенести?',
        answer: 'Сообщите нам как можно раньше. При отмене менее чем за 3 дня предоплата не возвращается, но её можно перенести на другую дату.'
    }
]